import { ErrorSharp } from "@mui/icons-material";
import { createContext, useEffect, useState } from "react";




export const ContactContext = createContext({
    contactMap: []
})

export const ContactProvider = ({ children }) => {
    const [contactMap, setContactMap] = useState([])

    useEffect(() => {
        // API endpoint disabled - using empty array
        // fetch("https://api.reverhotel.uz/form")
        //     .then(res => res.json())
        //     .then(respo => setContactMap(respo))
    }, []) // Fixed: removed contactMap from dependency to prevent infinite loop

    const value = { contactMap }

    return (
        <ContactContext.Provider value={value}>{children}</ContactContext.Provider>
    )
}